import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BatchApprovalPage } from '@/features/publish/pages/BatchApprovalPage';
import { batchSearchSchema } from '@/features/publish/types/publish.types';

export const Route = createFileRoute('/_auth/publish/mis')({
  validateSearch: batchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="MIS Publish Panel">
      <Suspense fallback={<PageLoader />}>
        <BatchApprovalPage stage="mis" />
      </Suspense>
    </ErrorBoundary>
  ),
});
